import React from "react";

const CustomButton = ({ text, styles }) => (
  <button type="button" className={`py-4 px-6 font-poppins font-medium text-[18px] text-primary bg-button rounded-[10px] outline-none ${styles}`}>
    {text}
  </button>
);

export default CustomButton;
